module.exports = {"500106001":"小龙坎街道","500106002":"沙坪坝街道","500106003":"渝碚路街道","500106004":"磁器口街道","500106005":"童家桥街道","500106006":"石井坡街道","500106007":"双碑街道","500106008":"井口街道","500106009":"歌乐山街道","500106010":"山洞街道","500106011":"新桥街道","500106012":"天星桥街道","500106013":"土湾街道","500106014":"覃家岗街道","500106015":"陈家桥街道","500106016":"虎溪街道","500106017":"西永街道","500106018":"联芳街道","500106019":"丰文街道","500106020":"香炉山街道","500106102":"井口镇","500106103":"歌乐山镇","500106104":"青木关镇","500106105":"凤凰镇","500106106":"回龙坝镇","500106108":"曾家镇","500106111":"土主镇","500106112":"中梁镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500106.json
// module id = 2217
// module chunks = 0